import { createApp, h } from 'vue'
import { InertiaProgress } from '@inertiajs/progress'
import {createInertiaApp, usePage} from '@inertiajs/inertia-vue3'

import Echo from 'laravel-echo';

import Pusher from 'pusher-js';
window.Pusher = Pusher;

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    wsHost: process.env.MIX_PUSHER_HOST,
    wsPort: process.env.MIX_PUSHER_PORT,
    wssPort: process.env.MIX_PUSHER_PORT,
    forceTLS: (process.env.MIX_PUSHER_SCHEME ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
    cluster: process.env.MIX_PUSHER_APP_CLUSTER
});

InertiaProgress.init({
    // The delay after which the progress bar will
    // appear during navigation, in milliseconds.
    delay: 100,

    // The color of the progress bar.
    color: '#e05820',

    // Whether to include the default NProgress styles.
    includeCSS: true,

    // Whether the NProgress spinner will be shown.
    showSpinner: true,
})

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  title: title => {

      title ? `${title} - Falcon` : 'Falcon';

      let notificationsCount = usePage().props.value.auth?.user?.app_unread_notifications_count ?? 0;
      if(notificationsCount > 0)
          title = `(${notificationsCount}) ` + title

      return title;
  },
  setup({ el, App, props, plugin }) {
    const app = createApp({ render: () => h(App, props) })
      .use(plugin)
        .mixin({methods: {route}})
      .mount(el)
  },
})
